import { useTheme } from 'styled-components'

export const useFormIconsStyle = () => {
  const { colors } = useTheme()
  const iconStyle = { color: colors.iconColor, fontSize: '15px' }
  return iconStyle
}
